/**
 * Small array helpers.
 *
 * State collections that the canonical semantic hash reads are held sorted and
 * duplicate-free, so that two states reached by different routes compare equal.
 * These functions are the only way those collections are written.
 */
/** A sorted, duplicate-free copy. */
export function sortedUnique(values) {
    const unique = [];
    for (const value of values)
        if (!unique.includes(value))
            unique.push(value);
    return unique.sort();
}
/** `values` with `additions` merged in, sorted and duplicate-free. */
export function addSorted(values, additions) {
    if (additions.length === 0)
        return values;
    return sortedUnique([...values, ...additions]);
}
/** `values` without any of `removals`, order preserved. */
export function removeAll(values, removals) {
    if (removals.length === 0)
        return values;
    return values.filter((value) => !removals.includes(value));
}
//# sourceMappingURL=collections.js.map